import { AjaxResponse } from 'rxjs/ajax';
import { HTTP_OK } from '../constants';

export const isRequestFailed = (ajaxResponse: AjaxResponse): boolean =>
  !ajaxResponse || ajaxResponse.status !== HTTP_OK;
